import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import * as filters from './filters'
import Api from './api'
import i18n from './services/i18n'
import Task from './services/task'
import Toast from './services/toast'
import Promise from 'bluebird'
import { sync } from 'vuex-router-sync'
import { installDirectives } from './directives'
import { installComponents } from './components/global'
import { isProd } from './utils'
import VueAnalytics from 'vue-analytics'

Vue.config.productionTip = false

installDirectives(Vue)

installComponents(Vue)

/* Use blurbird promise for cancellation feature */
Promise.config({ cancellation: true })

if (isProd) {
  Vue.use(Api)
} else {
  Vue.use(Api)
  // Vue.use(Api, { mode: 'mock' })
}

Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})

Vue.use(Task)

Vue.use(Toast)

Vue.use(i18n)

Vue.use(VueAnalytics, {
  id: 'UA-93831786-1',
  router
})

sync(store, router)

new Vue({
  router,
  store,
  ...App
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js